import React, { SVGProps } from 'react';

import { WOODSMOKE } from '@wetransfer/transfer/constant/colors';

export default function AlertIcon({
  color = WOODSMOKE,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Alert icon</title>
      <path
        d="M8.0002 5.99488V9.08896M6.68009 2.74034L0.92961 12.1499C0.299608 13.1807 1.04155 14.5036 2.24972 14.5036H13.7507C14.9588 14.5036 15.7008 13.1807 15.0708 12.1499L9.32031 2.74034C8.71705 1.75322 7.28334 1.75322 6.68009 2.74034Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <ellipse
        cx="7.99914"
        cy="11.4093"
        rx="0.773549"
        ry="0.773521"
        fill={color}
      />
    </svg>
  );
}
